import { HeaderGroup, RowData } from "@tanstack/react-table";
import { Skeleton } from "@radix-ui/themes";
import * as ShadcnTable from "@/v2/shared/shadcn-ui/table";

interface TableBodyLoaderProps<RowDataType extends RowData> {
  headerGroups: HeaderGroup<RowDataType>[];
}

export function TableBodyLoader<RowDataType extends RowData>({
  headerGroups,
}: TableBodyLoaderProps<RowDataType>) {
  const headerGroup = headerGroups[headerGroups.length - 1];

  return (
    <ShadcnTable.TableBody>
      {[...Array(10)].map((_, index) => (
        <ShadcnTable.TableRow
          key={index}
          style={{
            display: "flex",
            width: "100%",
            height: "48px",
          }}
        >
          {headerGroup.headers.map((header) => {
            const random = Math.round(Math.random() * 20) + 10;

            const { columnDef } = header.column;
            const align =
              (columnDef.meta as { align: string } | undefined)?.align ??
              "left";

            return (
              <ShadcnTable.TableCell
                key={header.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: align,
                  width: header.getSize(),
                }}
              >
                <Skeleton
                  loading
                  width={`calc(100% - ${random}%)`}
                  maxWidth={`calc(240px - ${random}px)`}
                  height={"20px"}
                  style={{
                    opacity: index < 5 ? 1 : 1 - 0.15 * (index - 4),
                  }}
                />
              </ShadcnTable.TableCell>
            );
          })}
        </ShadcnTable.TableRow>
      ))}
    </ShadcnTable.TableBody>
  );
}
